<template>
    <b-container>
        <p>Η διεύθυνση που έχετε καταχωρημένη στο TaxisNet έχει αλλάξει. Παρακαλούμε επικυρώστε τα στοιχεία σας πατώντας
            την επιλογή "Ατομικά στοιχεία" που βρίσκεται στο μενού.</p>
        <p><b>Στοιχεία διαμονής TaxisNet:</b></p>
        <table style="width:100%">
            <tr>
                <th>Οδός</th>
                <td>{{ adiavTaxis.residenceAddress }}</td>
            </tr>
            <tr>
                <th>Αριθμός</th>
                <td>{{ adiavTaxis.residenceAddressNo }}</td>
            </tr>
            <tr>
                <th>Περιοχή</th>
                <td>{{ adiavTaxis.residencePlace }}</td>
            </tr>
            <tr>
                <th>Ταχυδρομικός Κώδικας</th>
                <td>{{ adiavTaxis.residenceZip }}</td>
            </tr>
        </table>
    </b-container>
</template>

<script>
import {Structs} from "@/structs"

export default {
    name: 'TaxisCheckComponent',
    data() {
        return {
            adiavTaxis: Structs.AdiavTaxis()
        }
    },
    mounted() {
        let ref = this;
        this.$store.dispatch("loading")
        this.$http.get('/users/taxis').then(res => {
            ref.adiavTaxis = res.data.responseData
        }).catch((e) => {
                console.log(e);
            }
        ).finally(() => {
            this.$store.dispatch("stop_loading");
        })
    }
}
</script>